import { Axios } from 'utils'
import {
  ItemResponseType,
  ListPaginationParams,
  ListResponseType,
} from './types'
import {
  TInstrumentType,
  TInstrumentTypeWithId,
  TInstrument,
  TInstrumentWithId,
  TInstrumentTypeParsers,
} from 'types/models'

export const useInstrumentTypesService = () => {
  const getInstrumentTypes = async (pagination?: ListPaginationParams) => {
    try {
      const response = await Axios.get<ListResponseType<TInstrumentTypeWithId>>(
        '/instruments/types',
        {
          params: pagination
            ? {
                offset: pagination.currentPage * pagination.itemsPerPage,
                limit: pagination.itemsPerPage,
              }
            : undefined,
        }
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  const createInstrumentType = async (params: TInstrumentType) => {
    try {
      const response = await Axios.post<
        ItemResponseType<TInstrumentTypeWithId>
      >('/instruments/types', params)
      return response.data
    } catch (error) {
      throw error
    }
  }

  const updateInstrumentType = async (params: TInstrumentTypeWithId) => {
    try {
      const response = await Axios.put<ItemResponseType<TInstrumentTypeWithId>>(
        `/instruments/types/${params.id}`,
        params
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  const deleteInstrumentType = async (id: number) => {
    try {
      const response = await Axios.delete<{ status: boolean; detail: string }>(
        `/instruments/types/${id}`
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  const getInstrumentTypeParsers = async () => {
    try {
      const response = await Axios.get<
        ItemResponseType<TInstrumentTypeParsers>
      >('/instruments/types/parsers')
      return response.data
    } catch (error) {
      throw error
    }
  }

  return {
    getInstrumentTypes,
    createInstrumentType,
    updateInstrumentType,
    deleteInstrumentType,
    getInstrumentTypeParsers,
  }
}

export const useInstrumentsService = () => {
  const getInstruments = async (pagination?: ListPaginationParams) => {
    try {
      const response = await Axios.get<ListResponseType<TInstrumentWithId>>(
        '/instruments',
        {
          params: pagination
            ? {
                offset: pagination.currentPage * pagination.itemsPerPage,
                limit: pagination.itemsPerPage,
              }
            : undefined,
        }
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  const createInstrument = async (params: TInstrument) => {
    try {
      const response = await Axios.post<ItemResponseType<TInstrumentWithId>>(
        '/instruments',
        params
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  const updateInstrument = async (params: TInstrumentWithId) => {
    try {
      const response = await Axios.put<ItemResponseType<TInstrumentWithId>>(
        `/instruments/${params.id}`,
        params
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  const activateInstrument = async (id: number) => {
    try {
      const response = await Axios.post<ItemResponseType<TInstrumentWithId>>(
        `/instruments/${id}/activate`
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  const deactivateInstrument = async (id: number) => {
    try {
      const response = await Axios.post<ItemResponseType<TInstrumentWithId>>(
        `/instruments/${id}/deactivate`
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  const deleteInstrument = async (id: number) => {
    try {
      const response = await Axios.delete<{ status: boolean; detail: string }>(
        `/instruments/${id}`
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  return {
    getInstruments,
    createInstrument,
    updateInstrument,
    activateInstrument,
    deactivateInstrument,
    deleteInstrument,
  }
}
